var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import produce from 'immer';
import debounce from 'lodash/debounce';
import Select from '../../Forms/Fields/ReusableSelect';
import { Input } from '../../Forms/Fields';
import { PropertyName, PropertyRow } from './styles';
import { TooltipTopBar } from '../../../app-builder/utils/tooltipConfig';
var typeRequiresDotSyntax = function (t) { return t === 'json'; };
export var RowComponent = function (_a) {
    var row = _a.row, targetPatch = _a.targetPatch, sourceProperties = _a.sourceProperties, selectedEdge = _a.selectedEdge, onEdgeUpdated = _a.onEdgeUpdated, options = _a.options;
    var currentMaps = Object.keys(selectedEdge.meta.params).map(function (targetId) {
        if (!selectedEdge.meta.params[targetId].value &&
            typeof selectedEdge.meta.params[targetId] === 'string') {
            // Converting old format of params to new
            return {
                targetId: selectedEdge.meta.params[targetId],
                sourceId: targetId,
                value: '',
                type: '',
            };
        }
        return {
            targetId: targetId,
            sourceId: selectedEdge.meta.params[targetId].sourceId,
            value: selectedEdge.meta.params[targetId].value,
            type: selectedEdge.meta.params[targetId].type,
        };
    });
    var currentMap = currentMaps.find(function (map) { return map.targetId === row.id; });
    var selectedOption = options.find(function (option) { return currentMap && currentMap.sourceId === option.value; }) || null;
    var currentDotSyntax = (currentMap && currentMap.value) || '.';
    var sourceProperty = null;
    if (selectedOption && selectedOption.value && sourceProperties) {
        sourceProperty = sourceProperties.find(function (p) { return p.dataField === selectedOption.value; });
    }
    var updateEdge = function (newSelectedOption, newDotSyntax) {
        var _a;
        var requiresDotSyntaxOnUpdate = typeRequiresDotSyntax((_a = sourceProperties === null || sourceProperties === void 0 ? void 0 : sourceProperties.find(function (p) { return p.dataField === (newSelectedOption === null || newSelectedOption === void 0 ? void 0 : newSelectedOption.value); })) === null || _a === void 0 ? void 0 : _a.type);
        var newMaps = __spreadArray(__spreadArray([], currentMaps, true), [
            {
                targetId: row.id,
                sourceId: newSelectedOption && newSelectedOption.value,
                value: requiresDotSyntaxOnUpdate ? newDotSyntax : '.',
                type: row.type,
            },
        ], false);
        var reducedMaps = newMaps.reduce(function (acc, current) {
            if (current === null || current === void 0 ? void 0 : current.sourceId) {
                acc[current.targetId] = {
                    sourceId: current.sourceId,
                    value: current.value,
                    type: current.type,
                };
            }
            else {
                delete acc[current.targetId];
            }
            return acc;
        }, {});
        var newEdge = produce(selectedEdge, function (edge) {
            edge.meta.params = reducedMaps;
            return edge;
        });
        onEdgeUpdated(newEdge);
    };
    var debouncedUpdateEdge = debounce(function (newSelectedOption, newDotSyntax) {
        updateEdge(newSelectedOption, newDotSyntax);
    }, 500);
    var requiresDotSyntax = typeRequiresDotSyntax(sourceProperty && sourceProperty.type);
    return (_jsxs(PropertyRow, { children: [_jsx(PropertyName, { children: _jsxs(TooltipTopBar, __assign({ title: "".concat(targetPatch.name, " / ").concat(row.dataField) }, { children: ["Target:", _jsx("strong", { children: "".concat(targetPatch.name, " / ").concat(row.dataField) })] })) }), _jsx(Select, { value: selectedOption, options: options, onChange: function (newSelectedOption) {
                    updateEdge(newSelectedOption, currentDotSyntax);
                }, placeholder: "Connect input", isClearable: true }), requiresDotSyntax && (_jsx(Input, { type: "text", placeholder: "JSON path", defaultValue: currentDotSyntax, onChange: function (e) {
                    debouncedUpdateEdge(selectedOption, e.target.value);
                }, onKeyDown: function (e) { return e.stopPropagation(); } }))] }));
};
